const STAFF_FETCH_PROVIDERS = 'staff_fetch_providers';
const STAFF_FETCH_PROVIDERS_CSV = 'staff_fetch_providers_csv';
const STAFF_FETCH_PROVIDERS_SMALL = 'staff_fetch_providers_small';
const STAFF_FETCH_PROVIDERS_CONFIRMED_METRICS = 'staff_fetch_providers_confirmed_metrics';
const STAFF_FETCH_SUPERVISOR_PROVIDERS = 'staff_fetch_supervisor_providers';
const STAFF_FETCH_PROVIDER = 'staff_fetch_provider';
const STAFF_DELETE_PROVIDER = 'staff_delete_providers';
const STAFF_PERSIST_PROVIDER = 'staff_persist_providers';
const STAFF_CREATE_FILES_PROVIDER = 'staff_create_files_provider';
const STAFF_CREATE_FILES_PROVIDER_TYPE = 'staff_create_files_provider_type';
const STAFF_DELETE_FILE_PROVIDER = 'staff_delete_file_provider';
const STAFF_FETCH_FILES_PROVIDER = 'staff_fetch_files_provider';
const STAFF_UPDATE_CLAIM = 'staff_update_claim';
const STAFF_UPDATE_PROVIDER = 'staff_update_provider';

export default {
    STAFF_FETCH_PROVIDERS,
    STAFF_FETCH_PROVIDERS_CONFIRMED_METRICS,
    STAFF_FETCH_PROVIDERS_CSV,
    STAFF_FETCH_SUPERVISOR_PROVIDERS,
    STAFF_FETCH_PROVIDER,
    STAFF_DELETE_PROVIDER,
    STAFF_FETCH_PROVIDERS_SMALL,
    STAFF_PERSIST_PROVIDER,
    STAFF_UPDATE_PROVIDER,
    STAFF_UPDATE_CLAIM,
    STAFF_FETCH_FILES_PROVIDER,
    STAFF_DELETE_FILE_PROVIDER,
    STAFF_CREATE_FILES_PROVIDER,
    STAFF_CREATE_FILES_PROVIDER_TYPE,
};
